import { EventEmitter } from 'events'
import { storage } from './Storage'
import { debounce } from 'throttle-debounce'
import { APP_URL } from 'js/common/AppUrl';

class Customization extends EventEmitter {

	constructor() {
		super();

		this.storageData = null;
		this.STORAGE_KEY = 'aubade-sdb3d-customization'

		this.equipment 		= new Set();
		this.products 		= new Map();
		this.scene 			= undefined;
		this.uuid 			= null;


		this.floorTileId = 25;
		this.wallTileId = 28;

		this.eventQueue = new Set();

		this.attach();
	}

	attach = () => {
		// this.on("scene-loaded", this.save);
		this.on("product-added", this.save);
		this.on("product-removed", this.save);
		this.on("product-modified", this.save);
	}

	add(productCode, quantity = 1) {
		const product = storage.products.get(productCode);
		if (!product) return;

		const key = product.entity.entity_type.code;

		const isUser = [...this.equipment.values()].map(e => storage.equipment.get(e)).includes(product.entity.entity_type.equipment_id);

		if(this.products.has(key)){
			const {product:prd, quantity:qty} = this.products.get(key);
			if(prd.code == productCode) {
				this.products.set(key, {
					product,
					quantity:qty+quantity,
					isUser
				});
				if(isUser){
					storage.equipment.forEach((eqt, key) => {
						if(eqt.id == product.entity.entity_type.equipment_id){
							this.equipment.add(key)
						}
					})
				}
				this.emit("product-modified", key);
				return;
			}
			else this.remove(productCode);
		}
		this.products.set(key, {
			product,
			quantity,
			isUser
		});
		if(isUser){
			storage.equipment.forEach((eqt, key) => {
				if(eqt.id == product.entity.entity_type.equipment_id){
					this.equipment.add(key)
				}
			})
		}
		this.emit("product-added", key);
	}

	remove(productCode, quantity = 1) {
		const product = storage.products.get(productCode);
		if (!product) return;
		const key = product.entity.entity_type.code;

		if(this.products.has(key)) {
			const {
				product:prd,
				quantity:qty,
				isUser
			} = this.products.get(key);
			
			if(prd.code == productCode){
				if(qty - quantity <= 0){
					this.products.delete(key);
					this.emit("product-removed", key);
				}
				else{
					this.products.set(key, {product, quantity:qty - quantity, isUser})
					this.emit("product-modified", key);
				}
			}
		}
	}

	modify(oldProductSku, newProductSku, quantity = 1) {
		this.remove(oldProductSku, Infinity, true);
		this.add(newProductSku, quantity, true);
	}

	set(productCode, quantity = 1, isUser = false) {
		const product = storage.products.get(productCode);
		if (!product) return;

		const key = product.entity.entity_type.code;

		isUser = [...this.equipment.values()].map(e => storage.equipment.get(e).id).includes(product.entity.entity_type.equipment_id) || isUser;

		console.log('set', productCode, quantity, isUser);

		if(this.products.has(key)){
			const {product:prd, quantity:qty} = this.products.get(key);
			if(prd.code == productCode) {
				if(isUser){
					storage.equipment.forEach((eqt, key) => {
						if(eqt.id == product.entity.entity_type.equipment_id){
							if(quantity > 0)
								this.equipment.add(key)
							else{
								this.equipment.delete(key);
								isUser = false;
							}
						}
					})
				}
				this.products.set(key, {
					product,
					quantity:quantity,
					isUser:isUser
				});
				this.emit("product-modified", key);
				return;
			}
			else this.remove(productCode);
		}


		if(this.scene && this.scene.bathtub_or_shower){
			let isDouche 		= this.equipment.has('douche');
			const isBaignoire 	= this.equipment.has('baignoire');

			if(!isDouche && !isBaignoire)
				isDouche = true;

			if(isDouche && [...storage.equipment.values()].some((eqt) => eqt.id == product.entity.entity_type.equipment_id && eqt.slug == "baignoire")){
				return;
			}
			if(isBaignoire && [...storage.equipment.values()].some((eqt) => eqt.id == product.entity.entity_type.equipment_id && eqt.slug == "douche")){
				return;
			}
		}

		this.products.set(key, {
			product,
			quantity,
			isUser:isUser
		});
		if(isUser){
			storage.equipment.forEach((eqt, key) => {
				if(eqt.id == product.entity.entity_type.equipment_id){
					this.equipment.add(key)
				}
			})
		}
		this.emit("product-added", key);
	}

	setEquipment(equipment){
		this.products.clear();
		this.equipment.clear();
		if(equipment && equipment.length)
			equipment.forEach(eqt => this.equipment.add(eqt));
	}

	async setScene (slug, data = null) {
		if(this.scene && this.scene.slug == slug){
			if(data && data["equipment"])
				this.setEquipment(data["equipment"]);
			return false;
		}

		await storage.fetch(slug)
		this.scene = storage.scene;

		if(data && data.scene == this.scene.slug && data["equipment"]){
			this.setEquipment(data["equipment"]);
		}
		else this.setEquipment(storage.scene.equipment.map(eqt => eqt.slug));
		await this.queueEvent("scene-loaded");
	}

	getDatas = () => {
		return {
			uuid: 	this.uuid,
			equipment: 	[...this.equipment.values()].map(eqt => eqt),
			products: 	[...this.products.values()].map(({product, quantity, isUser}) => ({
				code: product.code,
				quantity: quantity,
				isUser: isUser,
			})),
			scene: this.scene ? this.scene.slug : null
		};
	}

	toJSON = () => {
		return JSON.stringify(this.getDatas())
	}

	getStoredData(){
		let data = window.localStorage.getItem(this.STORAGE_KEY);
		return data ? JSON.parse(data) : null;
	}

	save() {
		window.localStorage.setItem(this.STORAGE_KEY, this.toJSON())
	}

	clear(){
		const products = this.products.values();
		let next = products.next();
		while(!next.done){
			this.remove(next.value.product.code, Infinity)
			next = products.next();
		}
	}

	load = async (data = null) => {

		const stored = this.getStoredData();
		if(data == null) {
			data = stored ? stored : { scene:customization.scene.slug };

			this.clear();
		} 

		if (data["scene"]) {
			await this.setScene(data["scene"], stored);
		}

		if(data["equipment"]){
			this.setEquipment(data["equipment"])
		}
		if(data["uuid"]){
			this.uuid = data["uuid"];
		}

		if (data["products"]) {
			data["products"].forEach(({code, quantity, isUser}) => {
				this.set(code, quantity, isUser == 1);
			})
		}



		// Get default products
		if(this.products.size == 0){

			const dependencies = [];
			for(const product of this.scene.products){
				const prd = storage.products.get(product.code);

				if(prd){
					if(!this.scene.entity_types.some(type => type.id == prd.entity.entity_type_id)){
						//It's a dependency, process later
						dependencies.push(prd);
					}
					else{
						let quantity = 1;
						if(prd.entity.entity_type_id == this.floorTileId && prd.entity.install_price.type == "m2"){
							quantity = this.scene.floor_tiling_qty;
						}
						else if(prd.entity.entity_type_id == this.wallTileId && prd.entity.install_price.type == "m2"){
							quantity = this.scene.wall_tiling_qty;
						}
						this.set(product.code, quantity);
					}
				}
			}

			//Process dependencies
			dependencies.forEach(dependency => {
				const qty = this.scene.products.map(p => {
					const prd = storage.products.get(p.code);
					if(prd && prd.entity && prd.entity.dependencies)
						return prd.entity.dependencies.filter(d => d.id == dependency.entity.id).length;
					return 0;
				}).reduce((total, qty) => total + qty);

				if(qty > 0)
					this.set(dependency.code, qty);
			})
		}

		await this.queueEvent("customization-loaded");
	}

	queueEvent = (type, value = null) => {
		this.eventQueue.add({type, value});
		this.triggerEvents();
		return new Promise(resolve => {
			this.once(type, resolve);
		});
	}

	triggerEvents = debounce(100, () => {
		this.eventQueue.forEach(e => {
			this.eventQueue.delete(e);
			this.emit(e.type, e.value);
		});
	})



	calculatePriceHt() {
		return [...this.products.values()].filter(({isUser}) => isUser).reduce((acc, {product, quantity}) => {
			return acc + (product.price + (product.entity.install_price?product.entity.install_price.price:0)) * quantity
		}, 0);
	}

	formatPrice(price) {
		return Math.ceil(price).toLocaleString('ru-RU') + ' €';
	}

	get formattedTotalPriceHT () {
		return this.formatPrice(this.calculatePriceHt());
	}

	get formattedTotalPriceTVA () {
		return '+'+this.formatPrice(this.calculatePriceHt() * 0.1);
	}

	get formattedTotalPriceTTC () {
		return this.formatPrice(this.calculatePriceHt() * 1.1);
	}

	get totalPriceHT () {
		return this.calculatePriceHt();
	}

	get totalPriceTVA () {
		return this.calculatePriceHt();
	}

	get totalPriceTTC () {
		return this.calculatePriceHt();
	}

	async remoteSave(){
		this.save();

		const body = JSON.stringify({
			data:this.getDatas()
		});

		const CSRF = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

		if(this.uuid){
			await fetch(`${APP_URL}/storage/update-project/${this.uuid}`, {
				credentials: 'include',
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
        			'X-CSRF-TOKEN': CSRF
				},
				body: body
			});
		}
		else{
			const response = await fetch(`${APP_URL}/storage/create-project`, {
				credentials: 'include',
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
        			'X-CSRF-TOKEN': CSRF
				},
				body: body
			});

			const json = await response.json();

			this.uuid = json.uuid;
			this.save();
		}
	}
}

const customization = new Customization();

window["customization"] = customization; // TODO

export {customization}